@use '../../assets/styles/variables' as vars;
@use '../../assets/styles/medias' as medias;

.navbar {
  position: relative;
  font-weight: 300;

  @include medias.mobile-lg() {
    margin-left: -1.5rem;
  }

  @include medias.tablet() {
    margin-left: unset;
  }
}

.navbar__links {
  display: flex;
  gap: 16px;
  list-style: none;
  padding: 0;
  margin: 0;
}

.navbar__item {
  position: relative;
}

.navbar__link {
  display: block;
  padding: 1rem;
  color: vars.$white;
  text-decoration: none;

  &:hover {
    background-color: vars.$yellow;
  }

  &:active {
    opacity: 0.8;
  }
}

.navbar__dropdown {
  position: absolute;
  top: 100%;
  left: 0;
  background-color: vars.$darkblue;
  min-width: 200px;
  z-index: 1000;
}

.navbar__dropdown-list {
  list-style: none;
  padding: 0;
  margin: 0;
}

.navbar__dropdown-item {
  list-style: none;
  padding: 0;
}

.navbar__dropdown-link {
  display: block;
  padding: 1rem;
  text-decoration: none;
  color: inherit;

  &:hover {
    background-color: vars.$yellow;
  }

  &:active {
    opacity: 0.8;
  }
}
